// extracted by mini-css-extract-plugin
module.exports = {"content_section":"Cardonation_content_section__1btjc"};